<template>
    <div class="ui-date-range-picker-candidate ui-picker-month">
        <!-- * 月份选择器头部 -->
        <div class="ui-candidates-header">
            <!-- * 左侧控制器 -->
            <div class="ui-candidates-controls ui-candidates-left">
                <!-- * 年份控制器 -->
                <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() - 1 })">
                    <UiIcon name="arrow-double" />
                </div>
            </div>

            <!-- * 日期年月信息 -->
            <div class="ui-candidates-context">{{ date.getFullYear() }}年</div>

            <!-- * 右侧控制器 -->
            <div class="ui-candidates-controls ui-candidates-right">
                <!-- * 年份控制器 -->
                <div class="ui-candidates-control ui-candidates-year" @click="methods.date({ year: date.getFullYear() + 1 })">
                    <UiIcon name="arrow-double" />
                </div>
            </div>
        </div>

        <!-- * 月期选择器内容 -->
        <div class="ui-candidates-month">
            <template v-for="value in months">
                <div class="ui-candidate" :class="methods.get_month_status(value)" @click="methods.change(value)">{{ value + 1 }}月</div>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件引入
import UiIcon from "@various/components/icon";

//* 组件属性
import { useComposable } from "./src/composable";
import { ModulePickerEmits } from "../../src/types";

//* 组件属性注册
const emits = defineEmits(ModulePickerEmits);

//* 组合函数
const { refs, methods } = useComposable(emits);
const { months, date } = refs;
const { init, update } = methods;

defineExpose({ init, update });
</script>
